// When closing/reloading the tab must trigger the browser's "leave site?"
// confirm (UX audit 2026-06-10 finding B). Pure so the policy is unit-
// testable; App owns the actual beforeunload listener.
//
// Guard while:
//  - the tab is still REQUIRED: during the preview run and at preview-ready
//    the preview→full-run promotion happens client-side, so closing strands
//    a paid run (audit B5; the preview-ready resume branch also clears the
//    active-run pointer, so there is no way back);
//  - a passphrase is on screen and not yet acknowledged as saved: the server
//    re-serves it on reload while the run is in flight, but a CLOSE with no
//    saved key still risks the user never coming back to see it.
// Never guard past safe-to-close — the whole point of the email flow is
// that leaving is fine.
//
// run-complete is included in the same un-acked-passphrase check (pre-launch
// audit fix, 2026-07-04): the server discards its copy of the passphrase the
// moment the run completes, so a completed-but-unacked screen is the LAST
// chance to save it — closing the tab here is exactly as irrecoverable as
// closing it mid-convert. Mirrors App's holdForPassAck (RunState.tsx), which
// keeps the passphrase gate on screen through the same window.
export function shouldGuardUnload(args: {
  phaseKind: string;
  hasPassphrase: boolean;
  passSaved: boolean;
}): boolean {
  const { phaseKind, hasPassphrase, passSaved } = args;
  if (phaseKind === "preview-running" || phaseKind === "preview-ready") {
    return true;
  }
  if (phaseKind === "convert-running" || phaseKind === "run-complete") {
    return hasPassphrase && !passSaved;
  }
  return false;
}
